export class IngestionPipelineSpendLedgerRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hour",
            "baseName": "hour",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "ingestedBytes",
            "baseName": "ingestedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activeBytes",
            "baseName": "activeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "inactiveBytes",
            "baseName": "inactiveBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "metadataActiveBytes",
            "baseName": "metadataActiveBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "metadataInactiveBytes",
            "baseName": "metadataInactiveBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineSpendLedgerRow.attributeTypeMap;
    }
    constructor() {
    }
}
